import {Country} from './country';
import {Kpi} from './common';

import {PostChannel, PostType} from './post-overview';
import { RelatedInfluencer } from './influencer/related-influencer';

export class Influencer {
  id: number;
  influencer_id: number;
  influencer_name: string;
  influencer_image: string;
  influencer_group_id: number;
  country: Country | null;
  country_name: string;
  country_code: string;
  language: {
    id: number;
    code: string;
    name: string;
  };
  engagement: number;
  reach: number;
  impact: number;
  platform: string;
  company_id: number;
  stt: number;
  impression: number;
  isPending: boolean;
  profilePicture: string | null;
  domain: string | null;
  numberOfPosts: number | 0;
  numberOfFollowers: number | 0;
  description: string | null;
  selected: boolean;
  influencerChannels: any;

  topMention: string;
  favoriteTopics: string;
  numOfPostThisMonth: number;
  previewed: boolean;
  // use for discover post
  url: string;
  relativepath: string;
  url_hash: string;
  urlHash: string;
  imageUrl: string;
  channel: InfluencerChannel;
  isStory: boolean;
  completed: boolean;
  isVideo: boolean;
  mediaWidth: number;
  mediaHeight: number;
  campaign_influencer_id: number;
  influencerStatus: string;
  offsetId: number;
  isNewAdded: boolean;
  isFailedUpdate: boolean;
  // new campaign post
  newPosts: number;
}

export class InfluencerDetail {
  id: number | null;
  profilePicture: string | null;
  handles: string[] | null;
  groups: number[] | null;
  name: string | null;
  domain: string | null;
  language: {
    id: number;
    code: string;
    name: string;
  };
  country: Country | null;
  numberOfPosts: number | null;
  numberOfFollowers: number | null;
  description: string | null;
  reach: number | 0;
  impact: number | 0;
  engagement: number | 0;
  reachPercent: number | 0;
  impactPercent: number | 0;
  engagementPercent: number | 0;
  platforms: Platform[] | null;
  channels: InfluencerChannel[] | null;
  globalKpi: Kpi | null;
  platformReaches: any[] | null;
  topTopics: any[] | null;
  topMentions: any[] | null;
  average: any;
  channelGlobalKpis: Kpi[];
  channelAverageKpis: any[];
  creditAvailability: boolean;
  rawChannelGlobalKpis?: any[];
  relatedInfluencers: RelatedInfluencer[];
  brandMentions: string[];
  sponsoredOrganicPercentage: SponsoredOrganicPercentage[];
}

export class ChannelAudienceKPI {
  percent: number | null;
  platform: number | null;
  status: string | null;
  value: number | null;
}

export class PerformanceGlobalKPI {
  name: string | null;
  percent: number | null;
  status: string | null;
  value: number | null;
}

export class InfluencerChannel {
  id: number | null;
  handle: string | null;
  type: number | null;
  platform_id: number | null;
  blog_id: number | null;
  relativePath: string | null;
  isLinked: number | null;
  youtubeType: null;
  token: string | null;
  rss_url: string | null;
  note: string | null;
  platformName: string | null;
  blogId: number | null;
  platform: Platform;
  status: 'active' |' authorized' | 'deleted' | 'private' | 'not_found';
}

export class Platform {
  id: number | null;
  name: string | null;
  description: string | null;
  domain: string | null;
}

export class InfluencerPost {
  date: number | null;
  platformId: number | null;
  reach: number | null;
  impact: number | null;
  interaction: number;
  engagement: number | null;
  influencerName: string | null;
  title: string | null;
  mentions: Array<string> | null;
  url: string | null;
  relativepath: string | null;
  blog_id: number | null;
  imageUrl: string;
  videoUrl: string;
  platform: Platform | null;
  channel: PostChannel;
  urlHash: string | null;
  isStory: boolean;
  completed: boolean;
  isVideo: boolean;
  mediaWidth: number;
  mediaHeight: number;
  channelId: number;
  imageWidth: number;
  imageHeight: number;
  postType: PostType;
}

export class GaugeCircleChartData {
  contentPieChart: ContentPieChart;
  name: string;
  description: string;
  progressBar: ProgressBar;
  platformName: string;
}

export class ProgressBar {
  name: string;
  value: number;
}

export class ContentPieChart {
  engagement: PieChartValue;
  impression: PieChartValue;
  reach: PieChartValue;
}

export class PieChartValue {
  color: string;
  name: string;
  percent: number;
  status: string;
  value: number;
  tooltipInfo?: string;
}

export class PieChartData {
  engagement_value: number;
  impression_value: number;
  reach_value: number;
}

abstract class Exposure {
  author: string;
  influencer_id: number;
  relativepath: string;
  url: string;
  urlHash: string;
}

export class TopExposure extends Exposure {
  date: string;
  picture: string;
  title: string;
  value: number;
  platform: Platform;

  constructor(author = null, influencerId = null, relativePath = null, url = null, urlHash = null, date = null, picture = null, title = null, value = null, platform = null) {
    super();
    this.author = author;
    this.influencer_id = influencerId;
    this.relativepath = relativePath;
    this.url = url;
    this.urlHash = urlHash;
    this.title = title;
    this.value = value;
    this.platform = platform;
    this.date = date;
    this.picture = picture;
  }
}

export class BestPerformingExposure extends Exposure {
  pieCharts: any;
  platform: number;
  published_date: string;
  text: string;
  image: string;
  interaction: number;
}

export class AddInfluencerGroup {
  influencer_group_id: number;
  influencerGroupName: string;
  description: string;
  influencerList: number[] = [];
  reviewList: number[];
  addForReview: boolean;
}

export class AddPostToProject {
  projectId: number;
  projectName: string;
  posts: any[] = [];
}

export class PlatformReach {
  blog_id: number;
  channels: any[];
  country: any;
  countryCode: string;
  date: string;
  datePublished: string;
  domain: any;
  engagement: number;
  favouriteTopics: any[];
  followers: number;
  gender: string;
  id: number;
  imageUrl: string;
  impact: number;
  impressions: number;
  influencerName: string;
  influencer_country: string;
  influencer_country_id: number;
  influencer_name: string;
  keyword: any;
  keyword_id: number;
  keyword_type_id: number;
  mentions: any[];
  numberOfPosts: number;
  platform: any;
  platformId: number;
  platforms: any;
  project_id: number;
  rankingMetric: number;
  reach: number;
  relativepath: string;
  title: string;
  topics: any;
  url: string;
  urlType: number;
  url_hash: string;
  verticals: any;
}

export enum InfluencerIgStoryLoadingStatus {
  PENDING = 'PENDING',
  NO_STORY = 'NO_STORY',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}


export class InfluencerInfo {
  id: number | null;
  profilePicture: string | null;
  email: string;
  phone: string;
  name: string | null;
  domain: string | null;
  country: Country | null;
  systemEmail: string | null;
  status: number | null;
  influencerLanguages: any[];
  influencerChannels: any[];
  isActive: number;
  pending_completed: number;
  gender: number;
  acceptedTermService: boolean;
}

export enum ContactPermissionStatus {
  UNDEFINED = 'UNDEFINED',
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export class InfluencerConfirmationForm {
  fullName: string;
  email: string;
  constructor(fullName: string, email: string) {
    this.fullName = fullName;
    this.email = email;
  }
}

export enum RequestInfluencerType {
  CAMPAIGN_INVITATION = 'CAMPAIGN_INVITATION',
  CONTACT_PERMISSION = 'CONTACT_PERMISSION'
}

export class ChannelFollowers {
  influencer: ChannelFollowersInfluencer;
  channels: Array<ChannelFollowerItem> = [];
}

export class ChannelFollowersInfluencer {
  influencerId: number;
  followerCount: number;
  followerCountChange: number;
}

export class ChannelFollowerItem {
  channelId: number;
  handle: string;
  platformId: number;
  followerCount: number;
  followerCountChange: number;
  lastUpdated: Date;
}

export interface SponsoredOrganicPercentage {
  name: 'Sponsored' | 'Organic';
  percent: number;
}



// WEBPACK FOOTER //
// ./src/models/influencer.ts